import { IconButton } from "@mui/material";

import LocalPhoneIcon from "@mui/icons-material/LocalPhone";
import { AdditionalPhonesDialog } from "../../page/CustomerPage/Passport/AdditionalPhonesDialog/AdditionalPhonesDialog";
import { useDialogBetter } from "../../hooks/useDialogBetter";

/**
 * Button component that opens the additional phones for person
 */
export const AdditionalPhonesButton = ({ personId, companyId, readOnly=true, color = "" }) => {
  const { openDialog: openAdditionalPhonesForPersonDialog } = useDialogBetter();

  const handleClick = (e) => {
    e.stopPropagation();
    e.preventDefault();
    openAdditionalPhonesForPersonDialog({
      Component: AdditionalPhonesDialog,
      componentProps: {
        personId: personId,
        companyId: companyId,
        readOnly: readOnly,
      },
    });
  };

  return (
    <IconButton color={color} onClick={handleClick}>
      <LocalPhoneIcon />
    </IconButton>
  );
};
